export const paymentSummaryConfig = {
  title: 'Payment',
  desc: 'Complete the payment',
  summaryTitle: 'Payment Summary',
  prices: [
    {
      label: 'New Work Permit',
      price: '$48.09',
    },
  ],
  subTotalLabel: 'SubTotal',
  taxLabel: 'Tax',
  taxPrice: '$7.89',
  totalLabel: 'Total',
  totalDesc: '(Including Tax)',
  buttonLabel: 'Proceed to Payment',
  buttonVariant: 'secondary',
};
